import { GET, setParams } from '../_http';
import type { operations } from '@/types/schemas/calcs.main';
import type { PropertyTypeEnum } from '@/types/Property';
type controller = operations['StampDutyController_byPostCode'];

// `propertyType` is an optional query param on the calcs endpoint (used for property-type-specific rules
// such as the ACT commercial stamp duty exemption). Declared explicitly so this compiles regardless of
// whether the generated calcs types have been regenerated yet; run `npm run generate-apis` to formalise.
export type StampDutyParams = controller['parameters']['path'] & {
  propertyType?: PropertyTypeEnum;
};
export type StampDutyResponse = controller['responses']['200']['content']['application/json'];

export const stampDuty = GET(
  '/formulas/stamp-duty/post-code/{postCode}/{ownershipType}/{purchasePrice}',
  setParams<StampDutyParams>,
)<StampDutyResponse>;
